import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  MdDashboard,
  MdBusiness,
  MdGroup,
  MdPerson,
  MdLink,
  MdOutbox,
  MdAppShortcut,
  MdCloudSync
} from "react-icons/md"; // Import react-icons
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap icons CSS
import "./leftsidebar.css";
import { useAppContext } from "../../context/AppContext";
// Define the type for the links
type LinkItem = {
  to?: string;
  icon: React.ElementType | string; // React component or string for class
  label: string;
  type: "component" | "class"; // Type of icon
  children?: LinkItem[];
};

interface LeftSidebarProps {
  isSidebarExpanded: boolean;
  onSidebarHoverStart: () => void;
  onSidebarHoverEnd: () => void;
}

const LeftSidebar: React.FC<LeftSidebarProps> = ({
  isSidebarExpanded,
  onSidebarHoverStart,
  onSidebarHoverEnd,
}) => {
  const [expandedMenus, setExpandedMenus] = React.useState<{
    [key: string]: boolean;
  }>({});
  const location = useLocation(); // Get the current route
  const { userData } = useAppContext();

  console.log("userData==>App", userData);
  // Sidebar links array
  const links: LinkItem[] = [
    {
      to: "/dashboard",
      icon: MdDashboard,
      label: "Dashboard",
      type: "component",
    },
    {
      to: "/organization",
      icon: MdBusiness,
      label: "Organization",
      type: "component",
    },
    { to: "/users", icon: MdPerson, label: "Users", type: "component" },
    {
      to: "/usergroups",
      icon: MdGroup,
      label: "User Groups",
      type: "component",
    },
    {
      to: "/projects",
      icon: MdLink,
      label: "Projects",
      type: "component",
    },
    {
      to: "/projectsgroups",
      icon: "bi bi-diagram-3-fill", // Bootstrap icon class
      label: "Projects Groups",
      type: "class",
    },
    {
      icon: MdAppShortcut,
      label: "Integration",
      type: "component",
      children: [
        {
          to: "/drop-box",
          icon: MdOutbox,
          label: "DropBox",
          type: "component",
        },
        // {
        //   to: "/onedrive",
        //   icon: MdCloudSync,
        //   label: "OneDrive",
        //   type: "component",
        // },
        // {
        //   to: "/sharepoint",
        //   icon: MdOutbox,
        //   label: "SharePoint",
        //   type: "component",
        // },
      ],
    },
    {
      to: "/connection",
      icon: "bi-link-45deg", // Bootstrap icon class
      label: "Connection",
      type: "class",
    },
  ];

  if (userData?.roleID === 3) {
    links.push({
      to: "/tenants",
      icon: MdLink,
      label: "Tenants",
      type: "component",
    });
    // links.push({ to: "/tenant/:id", icon: MdLink, label: "Tenant Detail", type: "component" });
  }

  const toggleMenu = (label: string) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <aside
      className={`main-box ${isSidebarExpanded ? "expanded" : "collapsed"}`}
      onMouseEnter={onSidebarHoverStart}
      onMouseLeave={onSidebarHoverEnd}
    >
      <div className="sidebar-links">
        {links.map((item, index) => {
          const isActive = item.to && location.pathname === item.to;
          const isParent = !!item.children;

          return (
            <div
              key={index}
              className={`sidebar-item ${
                isSidebarExpanded ? "expanded" : "collapsed"
              } ${isActive ? "active" : ""} ${isParent ? "has-children" : ""}`}
            >
              {isParent ? (
                <>
                  <div
                    className={`sidebar-link ${
                      expandedMenus[item.label] ? "expanded" : ""
                    }`}
                    onClick={() => toggleMenu(item.label)}
                  >
                    <span className="icon">
                      {item.type === "component" ? (
                        <item.icon />
                      ) : (
                        <i className={`icon ${item.icon}`}></i>
                      )}
                    </span>
                    {isSidebarExpanded && (
                      <span className="label">{item.label}</span>
                    )}
                  </div>
                  {expandedMenus[item.label] && (
                    <div className="sidebar-submenu">
                      {item.children?.map((child, childIdx) => {
                        const isChildActive = child.to === location.pathname;
                        return (
                          <Link
                            to={child.to!}
                            key={childIdx}
                            className={`sidebar-link child-link ${
                              isChildActive ? "active" : ""
                            }`}
                          >
                            <span className="icon">
                              {child.type === "component" ? (
                                <child.icon />
                              ) : (
                                <i className={`icon ${child.icon}`}></i>
                              )}
                            </span>
                            {isSidebarExpanded && (
                              <span className="label">{child.label}</span>
                            )}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={item.to!}
                  className={`sidebar-link ${isActive ? "active" : ""}`}
                >
                  <span className="icon">
                    {item.type === "component" ? (
                      <item.icon />
                    ) : (
                      <i className={`icon ${item.icon}`}></i>
                    )}
                  </span>
                  {isSidebarExpanded && (
                    <span className="label">{item.label}</span>
                  )}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default LeftSidebar;
